import React, { useEffect } from 'react';
import './Competitions.css';

const Competitions: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="competitions-section">
            <div className="container">
                <h1 className="page-title">Benefits of entering competitions</h1>

                <div className="club-content">
                    <div className="content-section">
                        <div className="text-content">
                            <div className="photo-block">
                                <img className="inline-photo-right" src="/images/general/competition-group.jpg" alt="Students at a Taekwon-Do tournament" />
                                <p>
                                    The purpose of competition is to test your Taekwon-Do skills against others. This can be done in a class but lacks the competitive environment needed.
                                </p>
                                <p>
                                    At a competition / tournament, you will compete against students from other instructors, who may have different ways of fighting or performing patterns slightly differently. You are judged by referees who may have different views or opinions from your own or your instructor. Exposure to these different challenges at these events is an excellent way to learn, and will help to improve your technique, attitude, and fitness.
                                </p>
                            </div>

                            <div className="photo-block">
                                <img className="inline-photo-left" src="/images/general/competition-sparring.jpg" alt="Sparring action at competition" />
                                <p>
                                    There is a clear link between the results and confidence of those who do some competitions, over those who do not. Not just seen in class or gradings but in things like school work, exams, preparedness for interviews and life events. Competition is as much about mental preparation and readiness, as it is physical.
                                </p>
                                <p>
                                    There are always exceptions but our general experience is that those who have competed regularly, do better in their gradings or tests, purely from the experience and benefit of having had more exposure to a degree of pressure.
                                </p>
                            </div>

                            <div className="photo-block">
                                <img className="inline-photo-right" src="/images/general/competition-high-kick.jpg" alt="High kick performance at competition" />
                                <p>
                                    You can train in class several times a week, but competitions don't happen that frequently! You might go to one every few months at best, so when these opportunities do arise, they should be taken.
                                </p>
                                <p>
                                    These are also a great way to make new friends, not just in our club or the AETA, but also with other clubs and also to make friends from other countries.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="content-section">
                        <h2 className="comp-photos-title">From Our Competitions</h2>
                        <div className="comp-photo-grid">
                            <img src="/images/general/competition-medal-ceremony.jpg" alt="Medal ceremony presentation" />
                            <img src="/images/general/aeta-medals.jpg" alt="AETA gold, silver and bronze medals" />
                            <img src="/images/general/officials-selfie.jpg" alt="Club officials at competition" />
                        </div>
                        <img className="quote-image" src="/images/general/belt-goal-quote.jpg" alt="If knowledge is your goal, you will never stop training" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Competitions;
